import React from 'react'
import { ComponentCSSProp, styled } from '@grupoboticario/flora-react-system'
import { ColorThemeProps } from '@grupoboticario/flora'
export type IconProps = {
  /**
   * Tamanho do ícone, largura e altura iguais
   * @default 24
   * @example 16 | '16px' | '1em' | '1rem'
   */
  size?: number | string
  /**
   * Cor do ícone, aceita valores de tema de cor como tokens
   * @default 'currentColor'
   * @example '$statusErrorNonPrimaryButtonActive'
   */
  color?: ColorThemeProps | 'currentColor' | 'transparent'
  children?:
    | React.ReactElement<React.SVGProps<SVGSVGElement>>
    | React.ReactElement<React.SVGProps<SVGSVGElement>>[]
  /**
   * Título do ícone para acessibilidade
   * @example 'Ícone de um avião'
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/title
   */
  title?: string
  /**
   * ID do título do ícone para acessibilidade
   * @example 'airplane-icon-title'
   */
  titleId?: string
} & ComponentCSSProp &
  React.SVGProps<SVGSVGElement>

export const Icon = ({
  color = 'currentColor',
  size = 24,
  children,
  title,
  titleId,
  ...props
}: IconProps) => {
  const SvgStyled = styled('svg', {
    fill: color,
    width: size,
    height: size,
    ...(props.css || {}),
  })

  return (
    <SvgStyled
      {...(title && titleId
        ? {
            'aria-labelledby': titleId,
            role: 'img',
          }
        : {})}
      aria-hidden={title ? undefined : true}
      {...props}
    >
      {title && titleId && <title id={titleId}>{title}</title>}
      {children}
    </SvgStyled>
  )
}
